import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthGate } from "./AuthGate";
import { isSupabaseConfigured } from "./supabase";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

createRoot(root).render(
  <StrictMode>
    {isSupabaseConfigured ? (
      <AuthGate>{(session) => <App session={session} />}</AuthGate>
    ) : (
      <App session={null} localMode />
    )}
  </StrictMode>,
);
